import React from 'react';

export const languageIcons = {
  'PHP': (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#777BB4" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><ellipse cx="12" cy="12" rx="10" ry="6"/><text x="7" y="16" fontSize="7" fill="#777BB4">PHP</text></svg>
  ),
  'React': (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#61DAFB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="2"/><ellipse cx="12" cy="12" rx="10" ry="4"/><ellipse cx="12" cy="12" rx="4" ry="10" transform="rotate(60 12 12)"/><ellipse cx="12" cy="12" rx="4" ry="10" transform="rotate(120 12 12)"/></svg>
  ),
  'Node.js': (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#339933" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="12,2 22,7 22,17 12,22 2,17 2,7"/><text x="7" y="16" fontSize="7" fill="#339933">JS</text></svg>
  ),
  'Python': (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#3776AB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="4" y="4" width="16" height="16" rx="4"/><text x="7" y="16" fontSize="7" fill="#3776AB">Py</text></svg>
  ),
  'Java': (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#007396" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><ellipse cx="12" cy="12" rx="10" ry="6"/><text x="7" y="16" fontSize="7" fill="#007396">Java</text></svg>
  ),
  'Go': (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#00ADD8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="4" y="4" width="16" height="16" rx="4"/><text x="7" y="16" fontSize="7" fill="#00ADD8">Go</text></svg>
  ),
  'Ruby': (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#CC342D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><ellipse cx="12" cy="12" rx="10" ry="6"/><text x="7" y="16" fontSize="7" fill="#CC342D">Rb</text></svg>
  ),
};

export function getLanguageIcon(name) {
  const key = Object.keys(languageIcons).find(k => name.toLowerCase().includes(k.toLowerCase()));
  return languageIcons[key] || null;
}
